import groupOfficerReportTypes from './group-officer-report.types';

/** ***************** FETCH ALL GROUP OFFICER REPORT REPORT DETAILS START *********************** */
export const fetchAllGroupOfficerReportStart = (addData: any) => ({
	type: groupOfficerReportTypes.GET_GROUP_OFFICER_REPORT_START,
	payload: addData,
});

export const fetchAllGroupOfficerReportSuccess = (successData: any) => ({
	type: groupOfficerReportTypes.GET_GROUP_OFFICER_REPORT_SUCCESS,
	payload: successData,
});

export const fetchAllGroupOfficerReportFailure = (failureData: any) => ({
	type: groupOfficerReportTypes.GET_GROUP_OFFICER_REPORT_FAILURE,
	payload: failureData,
});

export const fetchAllGroupOfficerReportResponseReset = () => ({
	type: groupOfficerReportTypes.GET_GROUP_OFFICER_REPORT_RESPONSE_RESET_START,
});

export const fetchAllGroupOfficerReportResponseResetChanged = () => ({
	type: groupOfficerReportTypes.GET_GROUP_OFFICER_REPORT_RESPONSE_RESET_CHANGED,
});

/** ***************** FETCH ALL GROUP OFFICER REPORT DETAILS END *********************** */

/** ***************** FETCH ALL CENTER LIST BASED ON OFFICER START *********************** */
export const fetchAllCenterListForOfficerStart = (addData: any) => ({
	type: groupOfficerReportTypes.GET_CENTER_LIST_FOR_OFFICER_START,
	payload: addData,
});

export const fetchAllCenterListForOfficerSuccess = (successData: any) => ({
	type: groupOfficerReportTypes.GET_CENTER_LIST_FOR_OFFICER_SUCCESS,
	payload: successData,
});

export const fetchAllCenterListForOfficerFailure = (failureData: any) => ({
	type: groupOfficerReportTypes.GET_CENTER_LIST_FOR_OFFICER_FAILURE,
	payload: failureData,
});

export const fetchAllCenterListForOfficerResponseReset = () => ({
	type: groupOfficerReportTypes.GET_CENTER_LIST_FOR_OFFICER_RESPONSE_RESET_START,
});

export const fetchAllCenterListForOfficerResponseResetChanged = () => ({
	type: groupOfficerReportTypes.GET_CENTER_LIST_FOR_OFFICER_RESPONSE_RESET_CHANGED,
});

/** ***************** FETCH ALL CENTER LIST BASED ON OFFICER END *********************** */
